import PropTypes from 'prop-types';
import React, { Component } from 'react';
import events from './events';
import FindScrollableAncestor from './FindScrollableAncestor';

const { findScrollableAncestor } = FindScrollableAncestor;
/**
 * Point Cross originally authored by Rajendra kumar Vankadari
 */

const { on } = events;
const listeners = [];
let listenersToRemove = [];

/* istanbul ignore next */
class PointCross extends Component {
    static propTypes = {
        // inPoint: PropTypes.func,
        // beforePoint: PropTypes.func,
        // afterPoint: PropTypes.func,
        children: PropTypes.node,
        // bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        // topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        findYourAncestor: PropTypes.bool,
        // By default pointCross children will be loaded. Pass this as true to lazyload the children component.
        lazyLoadComponent: PropTypes.bool,
        // If true then component will be removed from listeners once its loaded.
        // once: PropTypes.bool,
        wrapperClass: PropTypes.string,
        loader: PropTypes.symbol,
    };

    static defaultProps = {
        inPoint: null,
        beforePoint: null,
        afterPoint: null,
        children: '',
        bottomOffset: 0,
        topOffset: 0,
        offset: 0,
        findYourAncestor: false,
        lazyLoadComponent: false,
        onEnterViewport: null,
        once: true,
        wrapperClass: '',
        loader: null,
    };

    constructor(props) {
        super(props);
        this.ticking = false;
        /* istanbul ignore if */
        if (typeof window !== 'undefined') {
            this.node = window;
        }

        /* istanbul ignore if */
        if (props.findYourAncestor) {
            this.node = findScrollableAncestor(this.rootNode);
        }
    }

    state = {
        loadComponent: false,
    };

    componentDidMount() {
        if (listeners.length === 0) {
            on(this.node, 'scroll', this.scrollEventCB);
            on(this.node, 'resize', this.scrollEventCB);
        }
        listeners.push(this);
        this.visibilityCheck(null, this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.adios) {
            //eslint-disable-line
            this.addToRemoveList(this);
        }
    }

    componentDidCatch(error) {
        console.log('PointCross Error - ', error);
    }

    ref = (node) => {
        this.rootNode = node;
    };

    scrollEventCB = (isInitial) => {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                listeners.forEach((activeListener) => {
                    this.visibilityCheck(isInitial, activeListener);
                });
                this.ticking = false;
            });
        }
        this.ticking = true;
        this.removeListeners();
        // listeners.forEach((activeListener) => {
        //     this.visibilityCheck(isInitial, activeListener);
        // });
    };

    invokeAction = (eventObj, elementDimension, activeListener) => {
        const { inPoint, beforePoint, afterPoint } = activeListener.props;

        const { getBoundingClientRect, offsetTop, offsetBottom } = elementDimension;

        const elementInPoint =
            Math.abs(parseInt(getBoundingClientRect.top, 0)) <= offsetTop ||
            Math.abs(parseInt(getBoundingClientRect.bottom, 0)) < offsetBottom;
        const elementBeforePoint = parseInt(getBoundingClientRect.top, 0) > offsetTop;
        const elementAfterPoint = parseInt(getBoundingClientRect.bottom, 0) < offsetBottom;

        if (activeListener.rootNode && (beforePoint || inPoint || afterPoint)) {
            if (elementBeforePoint) {
                beforePoint && beforePoint(eventObj);
            }

            if (elementInPoint) {
                inPoint && inPoint(eventObj);
            }

            if (elementAfterPoint) {
                afterPoint && afterPoint(eventObj);
            }
        }
    };

    addToRemoveList = (activeListener) => {
        if (activeListener.props.once) {
            listenersToRemove.push(activeListener);
        }
    };

    removeListeners = () => {
        listenersToRemove.forEach((activeListener) => {
            const listenerIndex = listeners.indexOf(activeListener);
            if (listenerIndex !== -1) {
                listeners.splice(listenerIndex, 1);
            }
        });
        listenersToRemove = [];
    };

    checkIfInViewport = (elementDimension, activeListener, lazyLoadComponent) => {
        const windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
        const {
            getBoundingClientRect: { top, height },
            offsetTop,
            offsetBottom,
        } = elementDimension;
        const { onEnterViewport } = activeListener.props;

        const showContent =
            top - offsetTop <= windowInnerHeight && top + height + offsetBottom >= 0;
        if (showContent) {
            this.addToRemoveList(activeListener);
            this.removeListeners();
            onEnterViewport && onEnterViewport();
            lazyLoadComponent &&
                activeListener.setState({
                    loadComponent: true,
                });
        }
    };

    visibilityCheck = (eventObj, activeListener) => {
        const {
            bottomOffset,
            offset,
            topOffset,
            lazyLoadComponent,
            onEnterViewport,
        } = activeListener.props;
        const offsetBottom = parseInt(offset || bottomOffset, 0);
        const offsetTop = parseInt(offset || topOffset, 0);
        if (activeListener.rootNode) {
            const getBoundingClientRect = activeListener.rootNode.getBoundingClientRect();
            const elementDimension = {
                getBoundingClientRect,
                offsetBottom,
                offsetTop,
            };
            if (lazyLoadComponent || onEnterViewport) {
                activeListener.checkIfInViewport(
                    elementDimension,
                    activeListener,
                    lazyLoadComponent
                );
            } else {
                activeListener.invokeAction(eventObj, elementDimension, activeListener);
            }
        }
    };

    render() {
        const { lazyLoadComponent, wrapperClass, loader } = this.props;
        const { loadComponent } = this.state;
        let displayComponent = true;
        if (lazyLoadComponent) {
            displayComponent = !!loadComponent;
        }
        return (
            <div ref={this.ref} className={wrapperClass}>
                {displayComponent ? this.props.children : loader}
            </div>
        );
    }
}

export default PointCross;
